// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from '../../../services/mock'

export const getData = createAsyncThunk('promoters/getData', async params => {

    let dataUsers = [
        {
            id: 1,
            billing: 'Manual - Credit Card',
            full_name: 'Galen Slixby',
            company: 'Yotz PVT LTD',
            role: 'editor',
            username: 'gslixby0',
            country: 'El Salvador',
            contact: '33 1234 5678',
            email: 'gslixby0@abc.net.au',
            currentPlan: 'enterprise',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/1.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            name: "Miguel Angel",
            lastName: "Lopéz",
            motherLastName: "García",
            gender: "Masculino",
            educationLevel: "Nivel Superior",
            profession: "Estudiandte",
            rfc: "VECJ880326",
            maritalStatus: "Soltero",
            address: {
                street: "Juan Palomar y Arias",
                outdoorNumber: 70,
                interiorNumber: 401,
                colony: "Vallarta Norte",
                postalCode: 45053,
                municipality: "Zapopan",
                city: "Zapopan",
                state: "Jalisco"
            },
            knowPerfectShopper: "rrss"

        },
        {
            id: 2,
            billing: 'Manual - Paypal',
            full_name: 'Halsey Redmore',
            company: 'Skinder PVT LTD',
            role: 'author',
            username: 'hredmore1',
            country: 'Albania',
            contact: '33 1234 5678',
            email: 'hredmore1@imgur.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/10.png'),
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: false,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 3,
            billing: 'Auto Debit',
            full_name: 'Marjory Sicely',
            company: 'Oozz PVT LTD',
            role: 'maintainer',
            username: 'msicely2',
            country: 'Russia',
            contact: '33 1234 5678',
            email: 'msicely2@who.int',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/1.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 4,
            billing: 'Manual - Credit Card',
            full_name: 'Cyrill Risby',
            company: 'Oozz PVT LTD',
            role: 'maintainer',
            username: 'crisby3',
            country: 'China',
            contact: '33 1234 5678',
            email: 'crisby3@wordpress.com',
            currentPlan: 'team',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 5,
            billing: 'Auto Debit',
            full_name: 'Maggy Hurran',
            company: 'Aimbo PVT LTD',
            role: 'subscriber',
            username: 'mhurran4',
            country: 'Pakistan',
            contact: '33 1234 5678',
            email: 'mhurran4@yahoo.co.jp',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/10.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 6,
            billing: 'Auto Debit',
            full_name: 'Silvain Halstead',
            company: 'Jaxbean PVT LTD',
            role: 'author',
            username: 'shalstead5',
            country: 'China',
            contact: '33 1234 5678',
            email: 'shalstead5@shinystat.com',
            currentPlan: 'company',
            status: 'active',
            avatar: '',
            avatarColor: 'light-success',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 7,
            billing: 'Manual - Paypal',
            full_name: 'Breena Gallemore',
            company: 'Jazzy PVT LTD',
            role: 'subscriber',
            username: 'bgallemore6',
            country: 'Canada',
            contact: '33 1234 5678',
            email: 'bgallemore6@boston.com',
            currentPlan: 'company',
            status: 'active',
            avatar: '',
            avatarColor: 'light-danger',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 8,
            billing: 'Manual - Cash',
            full_name: 'Kathryne Liger',
            company: 'Pixoboo PVT LTD',
            role: 'author',
            username: 'kliger7',
            country: 'France',
            contact: '33 1234 5678',
            email: 'kliger7@vinaora.com',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 9,
            billing: 'Auto Debit',
            full_name: 'Franz Scotfurth',
            company: 'Tekfly PVT LTD',
            role: 'subscriber',
            username: 'fscotfurth8',
            country: 'China',
            contact: '33 1234 5678',
            email: 'fscotfurth8@dailymotion.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/2.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 10,
            billing: 'Auto Debit',
            full_name: 'Jillene Bellany',
            company: 'Gigashots PVT LTD',
            role: 'maintainer',
            username: 'jbellany9',
            country: 'Jamaica',
            contact: '33 1234 5678',
            email: 'jbellany9@kickstarter.com',
            currentPlan: 'company',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 11,
            billing: 'Manual - Paypal',
            full_name: 'Jonah Wharlton',
            company: 'Eare PVT LTD',
            role: 'subscriber',
            username: 'jwharltona',
            country: 'United States',
            contact: '33 1234 5678',
            email: 'jwharltona@oakley.com',
            currentPlan: 'team',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/4.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 12,
            billing: 'Manual - Credit Card',
            full_name: 'Seth Hallam',
            company: 'Yakitri PVT LTD',
            role: 'subscriber',
            username: 'shallamb',
            country: 'Peru',
            contact: '33 1234 5678',
            email: 'shallamb@hugedomains.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/5.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 13,
            billing: 'Auto Debit',
            full_name: 'Yoko Pottie',
            company: 'Leenti PVT LTD',
            role: 'subscriber',
            username: 'ypottiec',
            country: 'Philippines',
            contact: '33 1234 5678',
            email: 'ypottiec@privacy.gov.au',
            currentPlan: 'basic',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/7.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 14,
            billing: 'Auto Debit',
            full_name: 'Maximilianus Krause',
            company: 'Digitube PVT LTD',
            role: 'author',
            username: 'mkraused',
            country: 'Democratic Republic of the Congo',
            contact: '33 1234 5678',
            email: 'mkraused@stanford.edu',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 15,
            billing: 'Auto Debit',
            full_name: 'Zsazsa McCleverty',
            company: 'Kaymbo PVT LTD',
            role: 'maintainer',
            username: 'zmcclevertye',
            country: 'France',
            contact: '33 1234 5678',
            email: 'zmcclevertye@soundcloud.com',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/2.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 16,
            billing: 'Auto Debit',
            full_name: 'Bentlee Emblin',
            company: 'Yambee PVT LTD',
            role: 'author',
            username: 'bemblinf',
            country: 'Spain',
            contact: '33 1234 5678',
            email: 'bemblinf@wired.com',
            currentPlan: 'company',
            status: 'active',
            avatar: require('@src/assets/images/avatars/6.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 17,
            billing: 'Manual - Paypal',
            full_name: 'Brockie Myles',
            company: 'Wikivu PVT LTD',
            role: 'maintainer',
            username: 'bmylesg',
            country: 'Poland',
            contact: '33 1234 5678',
            email: 'bmylesg@amazon.com',
            currentPlan: 'basic',
            status: 'active',
            avatar: '',
            avatarColor: 'light-warning',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 18,
            billing: 'Manual - Cash',
            full_name: 'Bertha Biner',
            company: 'Twinte PVT LTD',
            role: 'editor',
            username: 'bbinerh',
            country: 'Yemen',
            contact: '33 1234 5678',
            email: 'bbinerh@mozilla.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/7.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 19,
            billing: 'Manual - Cash',
            full_name: 'Travus Bruntjen',
            company: 'Cogidoo PVT LTD',
            role: 'admin',
            username: 'tbruntjeni',
            country: 'France',
            contact: '33 1234 5678',
            email: 'tbruntjeni@sitemeter.com',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: '',
            avatarColor: 'light-info',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        },
        {
            id: 20,
            billing: 'Auto Debit',
            full_name: 'Wesley Burland',
            company: 'Bubblemix PVT LTD',
            role: 'editor',
            username: 'wburlandj',
            country: 'Honduras',
            contact: '33 1234 5678',
            email: 'wburlandj@uiuc.edu',
            currentPlan: 'team',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/6.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331
        }

    ]
    return {
        params,
        data: dataUsers,
        total: dataUsers.length
    }
})

export const addPromoter = createAsyncThunk('promoters/addPromoter', async (promoter, { dispatch, getState }) => {
    let result = await axios.post('/apps/promoters/add-promoter', promoter)
    // await dispatch(getData(getState().promoters.params))
    // let result = true
    return result
})

export const updatePromoter = createAsyncThunk('promoters/updatePromoter', async (promoter, { dispatch, getState }) => {
    let result = await axios.post('/apps/promoters/update-promoter', promoter)
    // await dispatch(getData(getState().promoters.params))
    // let result = false
    return result
})

export const deletePromoter = createAsyncThunk('promoters/deletePromoter', async (id, { dispatch, getState }) => {
    await axios.delete('/apps/promoters/delete', { id })
    await dispatch(getData(getState().promoters.params))
    return id
})

export const getTotalPromoters = createAsyncThunk('promoters/getTotalPromoters', async () => {
    // const response = await axios.get('/api/promoters/getTotalPromoters')
    const responseDummy = {
        data: {
            totalPromoters: 1200,
            activePromoters: 980,
            inactivePromoters: 400
        }
    }
    return responseDummy.data
})

export const getPromoter = createAsyncThunk('promoters/getPromoter', async (id, { dispatch, getState }) => {
    // const response = await axios.get('/api/promoters/promote', { id })
    // return response.data.promoter
    const promoter = {
        data: {
            id: 1,
            billing: 'Manual - Credit Card',
            full_name: 'Galen Slixby',
            company: 'Yotz PVT LTD',
            role: 'editor',
            username: 'gslixby0',
            country: 'El Salvador',
            contact: '33 1234 5678',
            email: 'gslixby0@abc.net.au',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/1.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            creditUsed: 7000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            gender: "Femenino",
            maritalStatus: "Soltero",
            educationLevel: "Nivel Superior",
            profession: "Estudiandte",
            rfc: "VECJ880326",
            address: {
                street: "Juan Palomar y Arias",
                outdoorNumber: 70,
                interiorNumber: 401,
                colony: "Vallarta Norte",
                postalCode: 45053,
                municipality: "Zapopan",
                city: "Zapopan",
                state: "Jalisco"
            },
            vendors: [
                {
                    id: 1,
                    billing: 'Manual - Credit Card',
                    full_name: 'Galen Slixby',
                    company: 'Yotz PVT LTD',
                    role: 'editor',
                    username: 'gslixby0',
                    country: 'El Salvador',
                    contact: '33 1234 5678',
                    email: 'gslixby0@abc.net.au',
                    currentPlan: 'enterprise',
                    status: 'inactive',
                    avatar: require('@src/assets/images/avatars/1.png').default,
                    createdAt: "11/Sep/2022",
                    credit: 10000,
                    statusCredit: true,
                    discount: 10,
                    promoterCode: 44331
                },
                {
                    id: 2,
                    billing: 'Manual - Paypal',
                    full_name: 'Halsey Redmore',
                    company: 'Skinder PVT LTD',
                    role: 'author',
                    username: 'hredmore1',
                    country: 'Albania',
                    contact: '33 1234 5678',
                    email: 'hredmore1@imgur.com',
                    currentPlan: 'team',
                    status: 'active',
                    avatar: require('@src/assets/images/avatars/10.png'),
                    createdAt: "11/Sep/2022",
                    credit: 10000,
                    statusCredit: false,
                    promoterCode: 44331
                },
                {
                    id: 3,
                    billing: 'Auto Debit',
                    full_name: 'Marjory Sicely',
                    company: 'Oozz PVT LTD',
                    role: 'maintainer',
                    username: 'msicely2',
                    country: 'Russia',
                    contact: '33 1234 5678',
                    email: 'msicely2@who.int',
                    currentPlan: 'enterprise',
                    status: 'active',
                    avatar: require('@src/assets/images/avatars/1.png').default,
                    createdAt: "11/Sep/2022",
                    credit: 10000,
                    statusCredit: true,
                    discount: 10,
                    promoterCode: 44331
                },
                {
                    id: 4,
                    billing: 'Manual - Credit Card',
                    full_name: 'Cyrill Risby',
                    company: 'Oozz PVT LTD',
                    role: 'maintainer',
                    username: 'crisby3',
                    country: 'China',
                    contact: '33 1234 5678',
                    email: 'crisby3@wordpress.com',
                    currentPlan: 'team',
                    status: 'inactive',
                    avatar: require('@src/assets/images/avatars/9.png').default,
                    createdAt: "11/Sep/2022",
                    credit: 10000,
                    statusCredit: true,
                    discount: 10,
                    promoterCode: 44331
                },
                {
                    id: 5,
                    billing: 'Auto Debit',
                    full_name: 'Maggy Hurran',
                    company: 'Aimbo PVT LTD',
                    role: 'subscriber',
                    username: 'mhurran4',
                    country: 'Pakistan',
                    contact: '33 1234 5678',
                    email: 'mhurran4@yahoo.co.jp',
                    currentPlan: 'enterprise',
                    status: 'active',
                    avatar: require('@src/assets/images/avatars/10.png').default,
                    createdAt: "11/Sep/2022",
                    credit: 10000,
                    statusCredit: true,
                    discount: 10,
                    promoterCode: 44331
                },
                {
                    id: 6,
                    billing: 'Auto Debit',
                    full_name: 'Silvain Halstead',
                    company: 'Jaxbean PVT LTD',
                    role: 'author',
                    username: 'shalstead5',
                    country: 'China',
                    contact: '33 1234 5678',
                    email: 'shalstead5@shinystat.com',
                    currentPlan: 'company',
                    status: 'active',
                    avatar: '',
                    avatarColor: 'light-success',
                    createdAt: "11/Sep/2022",
                    credit: 10000,
                    statusCredit: true,
                    discount: 10,
                    promoterCode: 44331
                },
                {
                    id: 7,
                    billing: 'Manual - Paypal',
                    full_name: 'Breena Gallemore',
                    company: 'Jazzy PVT LTD',
                    role: 'subscriber',
                    username: 'bgallemore6',
                    country: 'Canada',
                    contact: '33 1234 5678',
                    email: 'bgallemore6@boston.com',
                    currentPlan: 'company',
                    status: 'active',
                    avatar: '',
                    avatarColor: 'light-danger',
                    createdAt: "11/Sep/2022",
                    credit: 10000,
                    statusCredit: true,
                    discount: 10,
                    promoterCode: 44331
                }
            ],
            sales: [
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "new"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000.50,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "pending"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "new"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "new"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "paid"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "paid"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    date: "04/Sep/2022",
                    status: "new"
                }
            ]
        }
    }
    return promoter.data

})

/* istanbul ignore next  */
mock.onGet('/apps/promoters/getPermissions').reply(config => {
    let response = {
        isFilterCatalog: true,
        products: {
            withDiscount: false,
            withoutDiscount: false
        }
    }
    // eslint-disable-next-line object-curly-newline
    return [
        200,
        {
            response: response
        }
    ]
})

export const getPermissions = createAsyncThunk('promoters/getPermissions', async () => {
    let response = await axios.get('/apps/promoters/getPermissions')
    return response.data.response
})


/* istanbul ignore next  */
mock.onPost('/apps/promoters/updatePermissions').reply(config => {
    // eslint-disable-next-line object-curly-newline
    return [
        200,
        {
            response: true
        }
    ]
})

export const updatePermissions = createAsyncThunk('promoters/updatePermissions', async (permissions) => {
    let response = await axios.post('/apps/promoters/updatePermissions', permissions)
    return response
})


export const promotersSlice = createSlice({
    name: 'promoters',
    initialState: {
        data: [],
        total: 1,
        params: {},
        totalPromoters: 0,
        activePromoters: 0,
        inactivePromoters: 0,
        selectedUser: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.params = action.payload.params
                state.total = action.payload.total
            })
            .addCase(getTotalPromoters.fulfilled, (state, action) => {
                state.totalPromoters = action.payload.totalPromoters
                state.activePromoters = action.payload.activePromoters
                state.inactivePromoters = action.payload.inactivePromoters
            })
            .addCase(getPromoter.fulfilled, (state, action) => {
                state.selectedUser = action.payload
            })
    }
})

export default promotersSlice.reducer
